import { Box } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EarlyFreedomCapitalSection } from "web_myplann/Inspiration/Components/EarlyFreedomCapitalSection";
import { EarlyFreedomPaceSection } from "web_myplann/Inspiration/Components/EarlyFreedomPaceSection";
import { EarlyFreedomPassiveSection } from "web_myplann/Inspiration/Components/EarlyFreedomPassiveSection";
import { EarlyFreedomReadyBox } from "web_myplann/Inspiration/Components/EarlyFreedomReadyBox";
import { EarlyFreedomTargetSection } from "web_myplann/Inspiration/Components/EarlyFreedomTargetSection";
import { InspirationTimeline } from "web_myplann/Inspiration/Components/InspirationTimeline";
import { EARLY_FREEDOM_PHASES } from "web_myplann/Inspiration/constants";
import type {
	EarlyFreedomContext,
	EarlyFreedomScenarioKey,
} from "web_myplann/Inspiration/Utils/earlyFreedomMath";

type Props = {
	context: EarlyFreedomContext;
	selectedScenario: EarlyFreedomScenarioKey;
	onChangeTarget: (value: number) => void;
	onChangeSaving: (value: number) => void;
	onSelectScenario: (scenario: EarlyFreedomScenarioKey) => void;
	onEditIncome: () => void;
	onContact: () => void;
};

export const EarlyFreedomResult: FC<Props> = ({
	context,
	selectedScenario,
	onChangeTarget,
	onChangeSaving,
	onSelectScenario,
	onEditIncome,
	onContact,
}) => {
	const { t } = useResource();

	return (
		<>
			<Box mt={0.8}>
				<EarlyFreedomTargetSection
					targetExpenses={context.targetExpenses}
					activeAnchorKey={context.activeAnchorKey}
					onChange={onChangeTarget}
				/>
			</Box>
			<Box mt={0.8}>
				<EarlyFreedomPassiveSection context={context} onEdit={onEditIncome} />
			</Box>
			{context.isEarlyFreedomReady ? (
				<Box mt={0.8}>
					<EarlyFreedomReadyBox context={context} onContact={onContact} />
				</Box>
			) : (
				<>
					<Box mt={0.8}>
						<EarlyFreedomCapitalSection context={context} />
					</Box>
					<Box mt={0.8}>
						<EarlyFreedomPaceSection
							context={context}
							selectedScenario={selectedScenario}
							onChange={onChangeSaving}
							onSelectScenario={onSelectScenario}
						/>
					</Box>
				</>
			)}
			<Box mt={0.8}>
				<InspirationTimeline
					title={t(Resources.Inspiration.EarlyFreedom.phasesTitle)}
					steps={EARLY_FREEDOM_PHASES}
				/>
			</Box>
		</>
	);
};
